import { z } from 'zod'

export const incomeResponseSchema = z.object({
  id: z.string().guid(),
  description: z.string().nullable(),
  amount: z.number(),
  currency: z.string(),
  spentAmount: z.number().nullable(),
  conversionRate: z.number().nullable(),
  date: z.string(),
  accountId: z.string().guid(),
  categoryId: z.string().guid(),
  userId: z.string().guid(),
  isSettlement: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
})

export type IncomeResponseDto = z.infer<typeof incomeResponseSchema>
